module.exports = __webpack_public_path__ + "media/images/dy_code-fdb4e703d0b42b59edb11c8db8beea0b.png";